import React from 'react';
import { Link } from 'react-router-dom';

import styles from '../../pages/listings.module.css';
import { truncate } from '../../utils/utils';

const STATUS_LABELS = {
  1: 'Sent',
  2: 'Viewed',
  3: 'Responded',
};

const formatDate = (date) => (date ? new Date(date).toLocaleString() : '-');

// Same as RFQSentTable but swaps the supplier columns for RFQ ID / RFQ Title
const SupplierRFQSentTable = ({ sentQueries }) => (
  <table className='table table-striped table-hover'>
    <thead>
      <tr className={styles.headings}>
        <th scope='col'>#</th>
        <th scope='col'>RFQ ID</th>
        <th scope='col'>RFQ Title</th>
        <th scope='col'>Email</th>
        <th scope='col'>Status</th>
        <th scope='col'>Notes</th>
        <th scope='col'>Sent At</th>
        <th scope='col'>Updated At</th>
      </tr>
    </thead>
    <tbody>
      {sentQueries.length > 0 ? (
        sentQueries.map((sentQuery, index) => (
          <tr key={sentQuery.id} className={styles.rows}>
            <th scope='row'>{index + 1}</th>
            <td>
              {sentQuery.rfqId ? (
                <Link to={`/quantila/rfq/${sentQuery.rfqId}`}>
                  {String(sentQuery.rfqId).replace(/\D/g, '').slice(-12)}
                </Link>
              ) : (
                '-'
              )}
            </td>
            <td>{truncate(sentQuery.rfqTitle || '-', 20)}</td>
            <td>{sentQuery.email}</td>
            <td>{STATUS_LABELS[sentQuery.status] || sentQuery.status}</td>
            <td>{truncate(sentQuery.notes || '-', 40)}</td>
            <td>{formatDate(sentQuery.createdAt)}</td>
            <td>{formatDate(sentQuery.updatedAt)}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={8}>No sent queries to display ...</td>
        </tr>
      )}
    </tbody>
  </table>
);

export default SupplierRFQSentTable;
